export const INGESTION_ANALYTICS_TAB = {
  ES_INDEXING: 0,
  ANALYTICS: 1,
  EXCEL_PROCESSING: 2,
  INDEX_MANAGEMENT: 3,
} as const;
